import { FormInstance, UploadFile } from 'antd';

export interface FeedResponseProps {
    readonly frequency: number;
    readonly is_active: boolean;
    readonly next_updated_at: Date;
    readonly shop_id: number;
    readonly url: string;

    readonly api_key?: string | boolean;
    readonly client_id?: string;
}

export interface FeedFormProps {
    readonly form: FormInstance<FeedProps>;
    readonly initial: FeedProps;
}

export enum FeedTypes {
    yml = 1,
    fileYml = 'fileYml',
    csvGoogleMerchant = 2,
    wildberries = 8,
    ozon = 10,
}

export interface FeedProps {
    readonly id?: number;
    readonly feed_url?: string;
    readonly feed_frequency?: number;
    readonly is_active?: boolean;
    readonly type?: FeedTypes;
    readonly feed_file?: UploadFile[];
}
